export class EventManager{
    private static LocalEvent:LocalEventManager=null;

    public static GetInstance():LocalEventManager{
        if((window as any).RNLocalEvent==null)
            (window as any).RNLocalEvent=new LocalEventManager();
        return (window as any).RNLocalEvent;
    }

    public static Publish<T extends EventBase>(event:T,defaultValue:any=null):T['ReturnType']{
        return EventManager.GetInstance().Publish<T>(event,defaultValue);
    }


    public static Subscribe<T extends EventBase>(event:{new(...any):T},callBack:(args?:T)=>void)
    {
        EventManager.GetInstance().Subscribe(event,callBack);
    }

    public static UnsubscribeEvent<T extends EventBase>(event:{new(...any):T},callBack:(args?:T)=>void)
    {
        EventManager.GetInstance().UnsubscribeEvent(event,callBack);
    }
}


export class LocalEventManager{

    private Events:any={};

    public Publish<T extends EventBase>(event:T,defaultValue:any=null):T['ReturnType']{
        let eventName=(event.constructor as any).GetName();
        if(this.Events[eventName]==null)
            return defaultValue;

        let eventsToCall:EventItem[]=this.Events[eventName];
        let result=null;
        for(let eventToCall of eventsToCall) {
            let aux;
            aux = eventToCall.CallBack(event);
            if(aux!=null)
                result=aux;
        }

        if(result==null)
            return defaultValue;
        return result;
    }


    public Subscribe<T extends EventBase>(event:{new():T},callBack:(args?:T)=>void)
    {
        let eventName=(event as any).GetName();
        if(this.Events[eventName]==null)
        {
            this.Events[eventName]=[];
        }

        this.Events[eventName].push(new EventItem(event as any,callBack));

    }

    public UnsubscribeEvent<T extends EventBase>(event:{new(...any):T},callBack:(args?:T)=>void)
    {
        let eventName=(event as any).GetName();
        let events:EventItem[]=this.Events[eventName];
        if(events==null)
            return;

        let item=events.find(x=>x.CallBack==callBack);
        if(item!=null)
            events.splice(events.indexOf(item),1);

        if(events.length==0)
            delete this.Events[eventName];

    }
}

class EventItem<T=any>{
    Event:EventBase;
    CallBack:(args?:T)=>void|any;
    protected ReturnType:T;

    constructor(event:EventBase,callBack:(args?:T)=>void|any)
    {
        this.Event=event;
        this.CallBack=callBack;
    }
}




export abstract class EventBase{
    public ReturnType:any;
    public static GetName(){
        throw new Error('Name was not defined');
    }

}